import React, { useState, useEffect } from 'react';
import ThemeCard from '../components/ThemeCard';
import './HomePage.css';

const HomePage = () => {
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    // Mock data - In production, this would fetch from the backend API
    const mockThemes = [
      {
        id: 1,
        title: 'No live chat support available',
        site: 'Airbnb',
        description: 'Airbnb lacks real-time chat support, making it difficult to resolve urgent booking issues or get immediate assistance during stays.',
        upvotes: 342,
        averageRating: 4.2,
        reviewCount: 87
      },
      {
        id: 2,
        title: 'Automated responses only',
        site: 'Kayak',
        description: 'Customer service relies heavily on automated responses with no option to speak with a human agent for complex travel issues.',
        upvotes: 218,
        averageRating: 3.8,
        reviewCount: 64
      },
      {
        id: 3,
        title: 'Long wait times for phone support',
        site: 'Airbnb',
        description: 'Phone support wait times exceed 2 hours during peak times, making it impractical for urgent matters.',
        upvotes: 456,
        averageRating: 4.5,
        reviewCount: 123
      },
      {
        id: 4,
        title: 'No refund policy for cancelled flights',
        site: 'Kayak',
        description: 'Kayak does not offer refunds for cancelled flights, only rebooking options which are often inconvenient.',
        upvotes: 289,
        averageRating: 3.9,
        reviewCount: 92
      },
      {
        id: 5,
        title: 'Limited language support',
        site: 'Airbnb',
        description: 'Customer support is only available in a few languages, making it difficult for international users.',
        upvotes: 167,
        averageRating: 3.5,
        reviewCount: 48
      }
    ];

    setTimeout(() => {
      setThemes(mockThemes);
      setLoading(false);
    }, 500);
  }, []);

  const filteredThemes = filter === 'all' 
    ? themes 
    : themes.filter(theme => theme.site.toLowerCase() === filter.toLowerCase());

  if (loading) {
    return <div className="loading">Loading themes...</div>;
  }

  return (
    <div className="home-page">
      <div className="page-header">
        <h2>Major Support Themes</h2>
        <p className="subtitle">
          Track and rate support themes from major platforms. Help others know what to expect.
        </p>
      </div>

      <div className="filters">
        <button 
          className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All Sites
        </button>
        <button 
          className={`filter-btn ${filter === 'airbnb' ? 'active' : ''}`}
          onClick={() => setFilter('airbnb')}
        >
          Airbnb
        </button>
        <button 
          className={`filter-btn ${filter === 'kayak' ? 'active' : ''}`}
          onClick={() => setFilter('kayak')}
        >
          Kayak
        </button>
      </div>

      <div className="themes-list">
        {filteredThemes.length > 0 ? (
          filteredThemes.map(theme => (
            <ThemeCard key={theme.id} theme={theme} />
          ))
        ) : (
          <div className="no-themes">No themes found for this filter.</div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
